import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

const TIPO_LABEL = { numeric: 'Número', text: 'Texto', boolean: 'Sí/No' };

const CLP = (n) =>
  Number(n || 0).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });

const INPUT_ST = {
  padding: '7px 10px', border: '1.5px solid #2E4A40', borderRadius: 8,
  fontSize: 15, width: 160, background: '#0D1311', color: '#F4F7F5',
  fontFamily: 'inherit',
};

export default function ConfiguracionSistema() {
  const [config, setConfig] = useState([]);
  const [editando, setEditando] = useState({});
  const [guardando, setGuardando] = useState({});
  const [mensajes, setMensajes] = useState({});
  const [loading, setLoading] = useState(true);

  const cargar = async () => {
    setLoading(true);
    try {
      const r = await api.get('/catalogo/configuracion');
      setConfig(r.data);
    } catch {
      // silencioso
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const iniciarEdicion = (clave, valorActual) => {
    setEditando(prev => ({ ...prev, [clave]: valorActual }));
    setMensajes(prev => ({ ...prev, [clave]: '' }));
  };

  const cancelar = (clave) => {
    setEditando(prev => { const n = { ...prev }; delete n[clave]; return n; });
  };

  const guardar = async (clave) => {
    const valor = editando[clave];
    if (valor === undefined || valor === '') return;
    setGuardando(prev => ({ ...prev, [clave]: true }));
    try {
      await api.put(`/catalogo/configuracion/${clave}`, { valor });
      setMensajes(prev => ({ ...prev, [clave]: 'ok' }));
      cancelar(clave);
      cargar();
    } catch (e) {
      setMensajes(prev => ({
        ...prev,
        [clave]: e.response?.data?.error || 'Error al guardar',
      }));
    } finally {
      setGuardando(prev => ({ ...prev, [clave]: false }));
    }
  };

  if (loading) return <p style={{ color: '#8A9994' }}>Cargando configuración…</p>;

  return (
    <div>
      <p style={{ color: '#8A9994', fontSize: 14, marginBottom: 20 }}>
        Parámetros globales que afectan el cálculo de presupuestos.
        Cambiar <strong style={{ color: '#C9D3CE' }}>valor HH</strong> recalcula automáticamente
        el precio de referencia de todos los ítems del catálogo que tienen horas-hombre.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 520 }}>
        {config.map(item => {
          const enEdicion = editando[item.clave] !== undefined;
          const msg = mensajes[item.clave];
          return (
            <div key={item.clave}
              style={{ background: '#161C19', borderRadius: 12, padding: 18,
                       border: '1px solid rgba(255,255,255,0.07)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between',
                            alignItems: 'flex-start', gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <span style={{ fontFamily: 'monospace', fontSize: 13, fontWeight: 700,
                                   color: '#4CAF50', background: '#12382D',
                                   borderRadius: 4, padding: '2px 7px' }}>
                      {item.clave}
                    </span>
                    <span style={{ fontSize: 11, color: '#6B7C74' }}>
                      {TIPO_LABEL[item.tipo] || item.tipo}
                    </span>
                  </div>
                  {item.descripcion && (
                    <p style={{ margin: '0 0 8px', fontSize: 13, color: '#8A9994' }}>
                      {item.descripcion}
                    </p>
                  )}

                  {enEdicion ? (
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                      <input
                        type={item.tipo === 'numeric' ? 'number' : 'text'}
                        value={editando[item.clave]}
                        onChange={e => setEditando(prev => ({ ...prev, [item.clave]: e.target.value }))}
                        onKeyDown={e => { if (e.key === 'Enter') guardar(item.clave); if (e.key === 'Escape') cancelar(item.clave); }}
                        autoFocus
                        style={{ ...INPUT_ST, border: '1.5px solid #0f6e56' }}
                      />
                      <button onClick={() => guardar(item.clave)}
                        disabled={guardando[item.clave]}
                        style={{ padding: '7px 14px', background: '#0f6e56', color: 'white',
                                 border: 'none', borderRadius: 8, cursor: 'pointer',
                                 fontWeight: 600, fontSize: 13, fontFamily: 'inherit' }}>
                        {guardando[item.clave] ? 'Guardando…' : 'Guardar'}
                      </button>
                      <button onClick={() => cancelar(item.clave)}
                        style={{ padding: '7px 12px', background: 'none',
                                 border: '1px solid rgba(255,255,255,0.12)',
                                 borderRadius: 8, cursor: 'pointer', fontSize: 13,
                                 color: '#8A9994', fontFamily: 'inherit' }}>
                        Cancelar
                      </button>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontSize: 20, fontWeight: 700, color: '#F4F7F5' }}>
                        {item.tipo === 'numeric' && item.clave.includes('hh')
                          ? CLP(item.valor)
                          : item.tipo === 'numeric' && item.clave.includes('iva')
                          ? `${item.valor}%`
                          : item.valor}
                      </span>
                      <button onClick={() => iniciarEdicion(item.clave, item.valor)}
                        style={{ padding: '5px 12px', border: '1px solid #2E4A40',
                                 borderRadius: 6, background: '#0D1311', color: '#4CAF50',
                                 cursor: 'pointer', fontSize: 12, fontWeight: 600,
                                 fontFamily: 'inherit' }}>
                        Editar
                      </button>
                    </div>
                  )}

                  {msg && msg !== 'ok' && (
                    <p style={{ margin: '6px 0 0', fontSize: 12, color: '#EF4444' }}>{msg}</p>
                  )}
                  {msg === 'ok' && (
                    <p style={{ margin: '6px 0 0', fontSize: 12, color: '#4CAF50' }}>✓ Guardado</p>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
